import { useTheme } from "@emotion/react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";
import useStyles from "./styles";
import { useEffect, useState } from "react";
const SelectionChart = ({ data = [] }) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [windowWith, setWindowWith] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
  }, []);
  const colors = [
    theme.palette.colors.blue.medium,
    theme.palette.colors.green.medium,
    theme.palette.colors.orange.medium,
    theme.palette.colors.red.medium,
    theme.palette.colors.purple.medium,
    theme.palette.colors.gray.medium,
  ];

  const chartData = data?.map((item, index) => ({
    ...item,
    color: colors[index % colors.length],
  }));

  /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Tooltip personalizado para a gr fico de sele o.
   *
   * @param {boolean} active - Flag que indica se o tooltip est  ativo.
   * @param {object} payload - Dados do tooltip.
   * @returns {JSX.Element | null} - O elemento do tooltip ou null se n o estiver ativo.
   */
  /*******  b21bf9ca-7c27-472a-952b-4bfe80e0a7e5  *******/
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <Box sx={styles.boxCustomLabel}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {data.name}
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            sx={{ fontWeight: "bold" }}
          >
            {`${data.value}% (${data.count} seleções)`}
          </Typography>
        </Box>
      );
    }
    return null;
  };

  const CustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    value,
    payload,
    fill,
  }) => {
    if (percent < 0.05 && payload?.name?.toLowerCase() !== "outros")
      return null;

    const isMobile = windowWith <= 600;

    const RADIAN = Math.PI / 180;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);

    const labelOffset1 = isMobile ? 5 : 10;
    const labelOffset2 = isMobile ? 15 : 30;
    const labelOffset3 = isMobile ? 12 : 22;

    const sx = cx + (outerRadius + labelOffset1) * cos;
    const sy = cy + (outerRadius + labelOffset1) * sin;
    const mx = cx + (outerRadius + labelOffset2) * cos;
    const my = cy + (outerRadius + labelOffset2) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * labelOffset3;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";
    const fontSize = isMobile ? 10 : 12;

    return (
      <g>
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 10}
          y={ey}
          textAnchor={textAnchor}
          fill={theme.palette.text.main}
          fontSize={fontSize}
        >
          {payload?.name}
        </text>
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 10}
          y={ey}
          dy={fontSize + 4}
          textAnchor={textAnchor}
          fill={theme.palette.text.secondary}
          fontSize={fontSize - 1}
        >
          {`(${(percent * 100).toFixed(2)}%)`}
        </text>
      </g>
    );
  };

  return (
    <Box sx={{ height: "50%" }}>
      <CardContent sx={{ height: "100%" }}>
        <Box sx={styles.boxCOntainer}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData?.length > 0 ? chartData : [{ value: 1 }]}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                label={
                  chartData?.length > 0 && windowWith > 600
                    ? CustomLabel
                    : false
                }
                dataKey="value"
                stroke="none"
              >
                {(chartData.length > 0
                  ? chartData
                  : [
                      {
                        color:
                          theme.palette.mode === "dark"
                            ? theme.palette.colors.black.medium
                            : theme.palette.colors.black.light,
                      },
                    ]
                )?.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>

              {chartData.length === 0 && (
                <text
                  x="50%"
                  y="50%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontSize={14}
                  fill={theme.palette.text.secondary}
                  fontWeight={500}
                >
                  Sem dados
                </text>
              )}

              {chartData?.length > 0 && (
                <>
                  <Tooltip content={<CustomTooltip />} />
                  {windowWith <= 600 && (
                    <Legend
                      layout="horizontal"
                      verticalAlign="bottom"
                      height={36}
                      formatter={(value, entry) => (
                        <span style={{ color: entry.color, fontWeight: 500 }}>
                          {value}
                        </span>
                      )}
                    />
                  )}
                </>
              )}
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Box>
  );
};

export default SelectionChart;
